<template>
    <div class="carousel__item">
        <slot></slot>
    </div>
</template>
